import { JSX } from "react";

import { WizardCustomer } from "models/wizard/WizardState";
import { getProjectOwners, getSalesPerson } from "./CustomerInformationHelper";
import WizardModule from "../wizardmodule/WizardModule";

import "./CustomerInformation.scss";

type Props = {
  showSaveButton: boolean;
  onSaveClick: () => void;
  customer: WizardCustomer;
  info?: string | JSX.Element;
  collapsed?: boolean;
};

export default function CustomerInformationEdit({
  showSaveButton,
  onSaveClick,
  customer,
  info,
  collapsed
}: Props) {
  return (
    <WizardModule
      showSaveButton={showSaveButton}
      onSaveClick={() => onSaveClick()}
      collapsed={collapsed}
      moduleTitle="Kunduppgifter"
      info={info}
    >
      <ul className="listStyle">
        <li>Kundnamn: {customer.customerName}</li>
        <li>Kundansvarig: {getSalesPerson(customer)}</li>
        <li>Kundnummer: {customer.id}</li>
        <li>Uppdragsansvariga: {getProjectOwners(customer)}</li>
        <li>Organisationsnummer: {customer.organizationNumber}</li>
      </ul>
    </WizardModule>
  );
}
